const url = window.location.hostname;
const target_port = window.location.port;

export const env: Record<
  'version' | 'project' | 'port' | 'backend_path' | 'mtls_path' | 'defaults',
  string | object | null
> = {
  version: '1.0.0',
  project: url.split('.')[0] as string,
  port: target_port,
  backend_path: 'api/',
  mtls_path: 'mtls/',
  defaults: {
    language: 'en-UK',
  }
};
